import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getUniversalOnboardingHostConfig } from "../../config/universalOnboardingHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";
import { usePermissionState } from "../../contexts/PermissionStateContext";

export const Route = createFileRoute("/integrations/universalOnboarding/$")({
  component: UniversalOnboardingMfePage,
});

function UniversalOnboardingMfePage() {
  const onNavigate = useHostNavigate();
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="universal-onboarding"
      props={{
        hostConfig: getUniversalOnboardingHostConfig(
          onNavigate,
          permissionState,
        ),
      }}
    />
  );
}
